import ctx from "../../plugins/axios";

/**
 * Undo the auto-archive of an expired specialty list (Admin/Super Admin only).
 *
 * Sends PUT /specialty_list/{uuid} with `action: "undo_archive"` so the backend
 * restores the list to APPROVED / active=true and applies an optional new
 * expiration_date. Default expiration is 30 days from un-archive date.
 *
 * @param {Object} params
 * @param {string} params.uuid              Target list uuid
 * @param {string} params.updated_by        Current user uuid
 * @param {string} [params.expiration_date] Optional new expiration date (YYYY-MM-DD), defaults to 30 days
 * @returns {Promise<*>}
 */
const undoArchiveList = async ({ uuid, updated_by, expiration_date }) => {
  const body = {
    action: "undo_archive",
    updated_by,
  };
  if (expiration_date) {
    // Align with backend storage format used elsewhere (YYYY-MM-DD HH:MM:SS)
    body.expiration_date = `${expiration_date} 00:00:00`;
  }
  return await ctx.put(`/specialty_list/${uuid}`, body);
};

export default undoArchiveList;
